import { useTrackTapCartIconOnCartOpen } from './useTrackTapCartIconOnCartOpen';

/** Mount when cart modal is open — fires tap_cart_icon after analytics get-cart response. */
const PulseTapCartIconTracker = ({ isCartOpen }: { isCartOpen: boolean }) => {
  useTrackTapCartIconOnCartOpen(isCartOpen);
  return null;
};

export default PulseTapCartIconTracker;
